export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            联系投稿
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            有料你就来，欢迎向我们提供线索或投稿
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            <div className="text-center p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-xl text-primary-500"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">tougao@chigua.example.com</p>
            </div>
            <div className="text-center p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">官方微信</h3>
              <p className="text-xs text-foreground-500">chigua_official</p>
            </div>
            <div className="text-center p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-weibo-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">官方微博</h3>
              <p className="text-xs text-foreground-500">@吃瓜在线官方</p>
            </div>
          </div>

          <div className="text-center p-6 rounded-xl bg-background-100">
            <i className="ri-information-line text-2xl text-primary-400 mb-3 block"></i>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">投稿须知</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              请提供详细的事件描述和相关证据材料，我们的编辑团队将在<strong className="text-foreground-700">24小时内</strong>进行审核。
              审核通过的内容将在平台发布，并为投稿人提供相应署名。期待您的精彩爆料，让我们一起分享最新鲜的吃瓜内容！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}